// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CodeblockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CodeblockIcon" ref={forwardedRef} {...props}>
      <path d="M6 3H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h-1.5v3.5h-11v-11H6z" />
      <path d="M10.332 8.829 7.504 6l2.828-2.828 1.063 1.062-1.77 1.77 1.766 1.766z" />
      <path d="m18.818 6-2.829-2.828L14.93 4.23l1.766 1.766-1.769 1.77 1.062 1.062z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CodeblockIcon = /* @__PURE__ */ Object.assign(
  CodeblockIconComponent,
  { displayName: 'CodeblockIcon' },
);
